<template>
    <RemoteComponent component="Header" />
</template>

<script>
 import RemoteComponent from '@/components/RemoteComponent.vue'
 export default {
    name: 'Header',
    components: {
        RemoteComponent
    },
    data () {
        return {
        
        }
    },
    mounted () {
    
    },
    methods: {
       
    },
}
</script>
<style>
</style>